import { createContext } from "react";

const DF_OT0011Context = createContext();

export { DF_OT0011Context };
